export default __webpack_public_path__ + "static/media/44.77bb3c71.jpg";